import { getApiHost } from '@/appSettings';
import { useLoginStore } from '@/login/stores/useLoginStore';
import { Api } from '@sysarb/sysarb-api';

/**
  * Retrieves the selected api manager by name from the api.
  * If it does not exist an error will be thrown.
  */
export function getApiManager(name: string): any {
    // Try to retrieve the correct api manager
    const store = useLoginStore();
    const api = new Api(store.instance, getApiHost());

    const manager: any = (api as any)[name];

    // Check that it actually exists
    if (manager == null) { throw new Error(`No manager named '${name}' exists in the server api.`); }

    // Return the api manager
    return manager;
}

export function useApi(instance?: string | null): Api {
    instance ??= useLoginStore().instance;
    const api = new Api(instance, getApiHost());
    return api;
}
